import {
  INVEST_PDF_OKRAJ_X,
  INVEST_PDF_SIRKA_OBSAHU,
  zabezpecInvestPdfMiesto,
} from "./investPdfPomocne";

const VLASTNA_VOLBA_KLUC = "vlastnaVolba";

const TRIEDY_AKTIV = Object.freeze([
  { kluc: "akcie", nazov: "Akcie", farba: [87, 173, 212] },
  { kluc: "dlhopisy", nazov: "Dlhopisy", farba: [167, 146, 93] },
  { kluc: "penazne", nazov: "Peňažné", farba: [122, 184, 140] },
  { kluc: "zmiesane", nazov: "Zmiešané", farba: [145, 121, 189] },
  { kluc: "komodity", nazov: "Komodity", farba: [213, 155, 82] },
  { kluc: "realitne", nazov: "Realitné", farba: [196, 117, 117] },
  {
    kluc: "alternativne",
    nazov: "Alternatívne",
    farba: [112, 135, 184],
  },
]);

const FARBA_NADPIS = [120, 102, 67];
const FARBA_TEXT = [45, 45, 45];
const FARBA_JEMNA = [105, 105, 105];
const FARBA_LINKA = [205, 196, 177];

const ROZLOZENIE =
  Object.freeze({
    padding: 4,
    vyskaNadpisu: 8,
    medzeraStlpcov: 3,
    minimalnaVyskaGrafu: 36,
    vyskaProduktu: 19.5,
    vyskaFondu: 6.6,
    odsadenieZaBlokom: 5,
  });

const TYPOGRAFIA_PRODUKTU =
  Object.freeze({
    jedenProdukt: {
      spolocnost: 6.7,
      nazov: 7.7,
      meta: 6.5,
    },

    viacProduktov: {
      spolocnost: 6.4,
      nazov: 7.3,
      meta: 6.2,
    },

    vlastnaVolba: {
      spolocnost: 6.4,
      nazov: 7.3,
      meta: 6.2,
      fond: 6.2,
    },
  });

function cislo(hodnota) {
  const vysledok = Number(hodnota);

  return Number.isFinite(vysledok)
    ? vysledok
    : 0;
}

function text(hodnota) {
  return String(hodnota || "").trim();
}

function formatujCislo(
  hodnota,
  maximumFractionDigits = 1
) {
  return cislo(hodnota).toLocaleString(
    "sk-SK",
    {
      minimumFractionDigits: 0,
      maximumFractionDigits,
    }
  );
}

function formatujMenu(
  hodnota,
  desatinne = false
) {
  return `${cislo(hodnota).toLocaleString(
    "sk-SK",
    {
      minimumFractionDigits: 0,
      maximumFractionDigits:
        desatinne ? 2 : 0,
    }
  )} €`;
}

function vytvorKlucProduktu(kod) {
  return `produkt:${kod}`;
}

function zistiCelkovyHorizont(
  variant
) {
  return (
    cislo(variant?.horizont) +
    (
      variant
        ?.dodatocneZhodnocovanieZapnute
        ? cislo(
            variant
              ?.dodatocneZhodnocovanieRoky
          )
        : 0
    )
  );
}

function rozdelSumuPodlaVah(
  polozky,
  suma
) {
  const sumaVCentoch = Math.round(
    cislo(suma) * 100
  );

  let rozdeleneCenty = 0;

  return polozky.reduce(
    (
      vysledok,
      polozka,
      index
    ) => {
      const centy =
        index === polozky.length - 1
          ? sumaVCentoch -
            rozdeleneCenty
          : Math.round(
              (
                sumaVCentoch *
                cislo(polozka.vaha)
              ) / 100
            );

      rozdeleneCenty += centy;

      vysledok[polozka.kluc] =
        centy / 100;

      return vysledok;
    },
    {}
  );
}

function vypocitajVazeneZhodnotenie(
  riadky
) {
  if (
    riadky.length === 0 ||
    !riadky.every(
      (riadok) =>
        riadok
          .priemerneZhodnotenie !==
          "" &&
        Number.isFinite(
          Number(
            riadok
              .priemerneZhodnotenie
          )
        )
    )
  ) {
    return null;
  }

  const sucetPodielov =
    riadky.reduce(
      (spolu, riadok) =>
        spolu +
        cislo(riadok.podiel),
      0
    );

  if (sucetPodielov <= 0) {
    return null;
  }

  return (
    riadky.reduce(
      (spolu, riadok) =>
        spolu +
        cislo(riadok.podiel) *
          cislo(
            riadok
              .priemerneZhodnotenie
          ),
      0
    ) / sucetPodielov
  );
}

function vytvorPolozkyZlozenia(
  zlozenieAktiv
) {
  if (
    !zlozenieAktiv ||
    zlozenieAktiv.variabilne
  ) {
    return [];
  }

  return TRIEDY_AKTIV
    .map((trieda) => ({
      ...trieda,
      podiel: cislo(
        zlozenieAktiv[
          trieda.kluc
        ]
      ),
    }))
    .filter(
      (trieda) =>
        trieda.podiel > 0
    );
}

function vytvorMetaProduktu(
  variant,
  sri,
  vaha,
  mesacne,
  jednorazovo
) {
  const meta = [];

  const horizont =
    zistiCelkovyHorizont(
      variant
    );

  if (horizont > 0) {
    meta.push(
      `Horizont: ${formatujCislo(
        horizont
      )} r.`
    );
  }

  if (
    Number.isFinite(sri) &&
    sri >= 1 &&
    sri <= 7
  ) {
    meta.push(`SRI: ${sri}`);
  }

  if (vaha !== null) {
    meta.push(
      `Váha: ${formatujCislo(
        vaha
      )} %`
    );
  }

  if (cislo(mesacne) > 0) {
    meta.push(
      `Mesačne: ${formatujMenu(
        mesacne,
        vaha !== null
      )}`
    );
  }

  if (cislo(jednorazovo) > 0) {
    meta.push(
      `Jednorazovo: ${formatujMenu(
        jednorazovo,
        vaha !== null
      )}`
    );
  }

  return meta;
}

function vytvorJedenProdukt({
  produkt,
  aktivnyVariant,
  analyzaVyberu,
}) {
  const meta =
    vytvorMetaProduktu(
      aktivnyVariant,
      Number(produkt?.SRI),
      null,
      aktivnyVariant
        ?.mesacnyVklad,
      aktivnyVariant
        ?.jednorazovyVklad
    );

  if (
    aktivnyVariant
      ?.jednorazovyPrivkladZapnuty &&
    cislo(
      aktivnyVariant
        ?.jednorazovyPrivklad
    ) > 0
  ) {
    meta.push(
      `Prívklad: ${formatujMenu(
        aktivnyVariant
          .jednorazovyPrivklad
      )}`
    );
  }

  const zlozenieAktiv =
    analyzaVyberu?.data
      ?.zlozenieAktiv ||
    produkt?.zlozenieAktiv;

  let domena = "";

  try {
    domena = new URL(
      produkt?.spolocnost?.odkaz
    ).hostname;
  } catch {
    domena = "";
  }

  return {
    typ: "jedenProdukt",

    produkt: {
      spolocnost: text(
        produkt?.spolocnost?.nazov
      ),

      nazov: text(
        produkt?.nazovProduktu
          ?.nazov ||
          produkt?.kod
      ),

      domena,
      meta,
    },

    zlozenie:
      vytvorPolozkyZlozenia(
        zlozenieAktiv
      ),

    zlozenieVariabilne:
      Boolean(
        zlozenieAktiv
          ?.variabilne
      ),
  };
}

function vytvorViacProduktov({
  zvoleneProdukty,
  maVlastnuVolbu,
  vlastnaVolbaProdukt,
  aktivneVahy,
  aktivnyVariant,
  analyzaVyberu,
}) {
  const polozky = [
    ...zvoleneProdukty.map(
      (produkt) => ({
        kluc:
          vytvorKlucProduktu(
            produkt.kod
          ),

        spolocnost: text(
          produkt?.spolocnost
            ?.nazov
        ),

        nazov: text(
          produkt
            ?.nazovProduktu
            ?.nazov ||
            produkt?.kod
        ),

        sri: Number(
          produkt?.SRI
        ),

        vaha: cislo(
          aktivneVahy[
            vytvorKlucProduktu(
              produkt.kod
            )
          ]
        ),
      })
    ),

    ...(
      maVlastnuVolbu
        ? [
            {
              kluc:
                VLASTNA_VOLBA_KLUC,

              spolocnost: text(
                vlastnaVolbaProdukt
                  ?.spolocnost
                  ?.nazov
              ),

              nazov: text(
                vlastnaVolbaProdukt
                  ?.nazovProduktu
                  ?.nazov ||
                  "Individuálny výber fondov"
              ),

              sri: Number(
                vlastnaVolbaProdukt
                  ?.SRI
              ),

              vaha: cislo(
                aktivneVahy[
                  VLASTNA_VOLBA_KLUC
                ]
              ),
            },
          ]
        : []
    ),
  ];

  const mesacneSumy =
    rozdelSumuPodlaVah(
      polozky,
      aktivnyVariant
        ?.mesacnyVklad
    );

  const jednorazoveSumy =
    rozdelSumuPodlaVah(
      polozky,
      aktivnyVariant
        ?.jednorazovyVklad
    );

  const zlozenieAktiv =
    analyzaVyberu?.data
      ?.zlozenieAktiv;

  return {
    typ: "viacProduktov",

    produkty: polozky.map(
      (polozka) => ({
        ...polozka,

        meta:
          vytvorMetaProduktu(
            aktivnyVariant,
            polozka.sri,
            polozka.vaha,
            mesacneSumy[
              polozka.kluc
            ],
            jednorazoveSumy[
              polozka.kluc
            ]
          ),
      })
    ),

    zlozenie:
      vytvorPolozkyZlozenia(
        zlozenieAktiv
      ),

    zlozenieVariabilne:
      Boolean(
        zlozenieAktiv
          ?.variabilne
      ),
  };
}

function vytvorVlastnuVolbu({
  vlastnaVolbaProdukt,
  zadaneRiadky,
  aktivnyVariant,
  analyzaVyberu,
}) {
  const meta = [];

  const horizont =
    zistiCelkovyHorizont(
      aktivnyVariant
    );

  const zhodnotenie =
    vypocitajVazeneZhodnotenie(
      zadaneRiadky
    );

  if (horizont > 0) {
    meta.push(
      `Horizont: ${formatujCislo(
        horizont
      )} r.`
    );
  }

  if (zhodnotenie !== null) {
    meta.push(
      `Ø p.a.: ${formatujCislo(
        zhodnotenie
      )} %`
    );
  }

  if (
    cislo(
      aktivnyVariant
        ?.mesacnyVklad
    ) > 0
  ) {
    meta.push(
      `Mesačne: ${formatujMenu(
        aktivnyVariant
          .mesacnyVklad
      )}`
    );
  }

  if (
    cislo(
      aktivnyVariant
        ?.jednorazovyVklad
    ) > 0
  ) {
    meta.push(
      `Jednorazovo: ${formatujMenu(
        aktivnyVariant
          .jednorazovyVklad
      )}`
    );
  }

  const zlozenieAktiv =
    analyzaVyberu?.data
      ?.zlozenieAktiv;

  return {
    typ: "vlastnaVolba",

    spolocnost: text(
      vlastnaVolbaProdukt
        ?.spolocnost?.nazov
    ),

    nazov: text(
      vlastnaVolbaProdukt
        ?.nazovProduktu?.nazov ||
        "Individuálny výber fondov"
    ),

    fondy: zadaneRiadky.map(
      (riadok) => ({
        id: riadok.id,
        nazov: text(
          riadok.nazov
        ),
        podiel: cislo(
          riadok.podiel
        ),
      })
    ),

    meta,

    zlozenie:
      vytvorPolozkyZlozenia(
        zlozenieAktiv
      ),

    zlozenieVariabilne:
      Boolean(
        zlozenieAktiv
          ?.variabilne
      ),
  };
}

export function vytvorInvestPdfOdporucania({
  variantKluc,
  aktivnyVariant,
  zvoleneProdukty,
  maProduktovyVyber,
  maVlastnuVolbu,
  vlastnaVolbaJeVybrana,
  vlastnaVolbaProdukt,
  zadaneRiadky,
  aktivneVahy,
  vahyVyberuSuPlatne,
  analyzaVyberu,
}) {
  const produkty =
    Array.isArray(
      zvoleneProdukty
    )
      ? zvoleneProdukty
      : [];

  const fondy =
    Array.isArray(
      zadaneRiadky
    )
      ? zadaneRiadky
      : [];

  const pocetRieseni =
    produkty.length +
    (
      vlastnaVolbaJeVybrana
        ? 1
        : 0
    );

  let obsah = null;

  if (
    maProduktovyVyber &&
    produkty.length === 1 &&
    !vlastnaVolbaJeVybrana
  ) {
    obsah =
      vytvorJedenProdukt({
        produkt: produkty[0],
        aktivnyVariant,
        analyzaVyberu,
      });
  } else if (
    pocetRieseni >= 2 &&
    (
      !vlastnaVolbaJeVybrana ||
      maVlastnuVolbu
    ) &&
    vahyVyberuSuPlatne
  ) {
    obsah =
      vytvorViacProduktov({
        zvoleneProdukty:
          produkty,
        maVlastnuVolbu,
        vlastnaVolbaProdukt,
        aktivneVahy:
          aktivneVahy || {},
        aktivnyVariant,
        analyzaVyberu,
      });
  } else if (
    maVlastnuVolbu &&
    produkty.length === 0
  ) {
    obsah =
      vytvorVlastnuVolbu({
        vlastnaVolbaProdukt,
        zadaneRiadky: fondy,
        aktivnyVariant,
        analyzaVyberu,
      });
  }

  if (!obsah) {
    return null;
  }

  return {
    variant:
      variantKluc === "variant2"
        ? "Variant 2"
        : "Variant 1",

    ...obsah,
  };
}

export function maInvestPdfOdporucania(
  odporucania
) {
  return Boolean(
    odporucania &&
      [
        "jedenProdukt",
        "viacProduktov",
        "vlastnaVolba",
      ].includes(
        odporucania.typ
      )
  );
}

function nastavFarbu(
  pdf,
  farba,
  ciel = "text"
) {
  if (ciel === "draw") {
    pdf.setDrawColor(...farba);
  } else if (ciel === "fill") {
    pdf.setFillColor(...farba);
  } else {
    pdf.setTextColor(...farba);
  }
}

function zapisZalamanyText(
  pdf,
  hodnota,
  x,
  y,
  sirka,
  moznosti = {}
) {
  const riadky =
    pdf.splitTextToSize(
      text(hodnota),
      sirka
    );

  pdf.text(
    riadky,
    x,
    y,
    moznosti
  );

  return riadky.length;
}

function zapisProdukt(
  pdf,
  produkt,
  x,
  y,
  sirka,
  vyska,
  {
    typografia =
      TYPOGRAFIA_PRODUKTU
        .viacProduktov,
    zobrazDeliciuCiaru = true,
  } = {}
) {
  pdf.setFont(
    "Inter",
    "normal"
  );
  pdf.setFontSize(
    typografia.spolocnost
  );
  nastavFarbu(
    pdf,
    FARBA_JEMNA
  );

  if (produkt.spolocnost) {
    pdf.text(
      produkt.spolocnost,
      x,
      y + 3.3
    );
  }

  pdf.setFont(
    "Inter",
    "bold"
  );
  pdf.setFontSize(
    typografia.nazov
  );
  nastavFarbu(
    pdf,
    FARBA_TEXT
  );

  const posunNazvu =
    produkt.spolocnost
      ? 6.5
      : 3.5;

  const pocetRiadkov =
    zapisZalamanyText(
      pdf,
      produkt.nazov,
      x,
      y + posunNazvu,
      sirka,
      {
        lineHeightFactor: 1.05,
      }
    );

  pdf.setFont(
    "Inter",
    "normal"
  );
  pdf.setFontSize(
    typografia.meta
  );
  nastavFarbu(
    pdf,
    FARBA_JEMNA
  );

  const vyskaRiadkaNazvu =
    typografia.nazov * 0.37;

  const metaY =
    y +
    posunNazvu +
    pocetRiadkov *
      vyskaRiadkaNazvu +
    1.2;

  zapisZalamanyText(
    pdf,
    produkt.meta.join(
      "  |  "
    ),
    x,
    metaY,
    sirka,
    {
      lineHeightFactor: 1.05,
    }
  );

  if (!zobrazDeliciuCiaru) {
    return;
  }

  nastavFarbu(
    pdf,
    FARBA_LINKA,
    "draw"
  );

  pdf.setLineWidth(0.18);

  pdf.line(
    x,
    y + vyska,
    x + sirka,
    y + vyska
  );
}

function zapisFondy(
  pdf,
  x,
  y,
  sirka,
  fondy
) {
  let aktualneY = y;

  fondy.forEach((fond) => {
    pdf.setFont(
      "Inter",
      "normal"
    );
    pdf.setFontSize(
      TYPOGRAFIA_PRODUKTU
        .vlastnaVolba
        .fond
    );
    nastavFarbu(
      pdf,
      FARBA_TEXT
    );

    pdf.text(
      fond.nazov,
      x,
      aktualneY + 3.2,
      {
        maxWidth:
          sirka - 12,
      }
    );

    pdf.setFont(
      "Inter",
      "bold"
    );

    pdf.text(
      `${formatujCislo(
        fond.podiel
      )} %`,
      x + sirka,
      aktualneY + 3.2,
      {
        align: "right",
      }
    );

    nastavFarbu(
      pdf,
      FARBA_LINKA,
      "draw"
    );

    pdf.setLineWidth(0.15);

    pdf.line(
      x,
      aktualneY + 5.1,
      x + sirka,
      aktualneY + 5.1
    );

    aktualneY +=
      ROZLOZENIE.vyskaFondu;
  });

  return aktualneY;
}

function vytvorDonutDataUrl(
  polozky
) {
  if (
    typeof document ===
      "undefined" ||
    polozky.length === 0
  ) {
    return "";
  }

  const canvas =
    document.createElement(
      "canvas"
    );

  canvas.width = 300;
  canvas.height = 300;

  const kontext =
    canvas.getContext("2d");

  if (!kontext) {
    return "";
  }

  const stred = 150;
  const polomer = 104;
  const hrubka = 42;

  let uhol =
    -Math.PI / 2;

  const sucet =
    polozky.reduce(
      (spolu, polozka) =>
        spolu +
        polozka.podiel,
      0
    ) || 100;

  polozky.forEach(
    (polozka) => {
      const dalsiUhol =
        uhol +
        (
          Math.PI *
          2 *
          polozka.podiel
        ) /
          sucet;

      kontext.beginPath();

      kontext.arc(
        stred,
        stred,
        polomer,
        uhol,
        dalsiUhol
      );

      kontext.strokeStyle =
        `rgb(${polozka.farba.join(
          ","
        )})`;

      kontext.lineWidth =
        hrubka;

      kontext.stroke();

      uhol = dalsiUhol;
    }
  );

  kontext.fillStyle =
    "#2d2d2d";

  kontext.textAlign =
    "center";

  kontext.font =
    "600 24px Arial";

  kontext.fillText(
    "Triedy",
    stred,
    stred - 3
  );

  kontext.font =
    "700 28px Arial";

  kontext.fillText(
    "100 %",
    stred,
    stred + 29
  );

  return canvas.toDataURL(
    "image/png"
  );
}

function zapisZlozenie(
  pdf,
  odporucania,
  x,
  y,
  sirka,
  {
    zvacsenyGraf = false,
  } = {}
) {
  pdf.setFont(
    "Inter",
    "bold"
  );
  pdf.setFontSize(6.2);
  nastavFarbu(
    pdf,
    FARBA_TEXT
  );

  pdf.text(
    "Zloženie tried aktív",
    x + sirka / 2,
    y + 3.2,
    {
      align: "center",
    }
  );

  if (
    odporucania
      .zlozenie.length === 0
  ) {
    pdf.setFont(
      "Inter",
      "normal"
    );
    pdf.setFontSize(5.8);
    nastavFarbu(
      pdf,
      FARBA_JEMNA
    );

    pdf.text(
      odporucania
        .zlozenieVariabilne
        ? "Zloženie aktív nie je pevne určené."
        : "Zloženie tried aktív nie je dostupné.",
      x + sirka / 2,
      y + 20,
      {
        align: "center",
        maxWidth:
          sirka - 4,
      }
    );

    return;
  }

  const donut =
    vytvorDonutDataUrl(
      odporucania.zlozenie
    );

  const priemer = Math.min(
  zvacsenyGraf
    ? 35
    : 29,
  sirka *
    (
      zvacsenyGraf
        ? 0.52
        : 0.48
    )
);

const dostupnaLegendaSirka =
  Math.max(
    18,
    sirka - priemer - 5
  );

const legendaSirka =
  zvacsenyGraf
    ? Math.min(
        30,
        dostupnaLegendaSirka
      )
    : dostupnaLegendaSirka;

const obsahSirka =
  priemer +
  4 +
  legendaSirka;

const obsahX =
  zvacsenyGraf
    ? x +
      (
        sirka -
        obsahSirka
      ) / 2
    : x;

const donutX =
  obsahX + 1;

  if (donut) {
    pdf.addImage(
      donut,
      "PNG",
      donutX,
      y + 6,
      priemer,
      priemer
    );
  }

  let legendaY = y + 9;

  const legendaX =
  obsahX + priemer + 4;

  odporucania.zlozenie.forEach(
    (polozka) => {
      nastavFarbu(
        pdf,
        polozka.farba,
        "fill"
      );

      pdf.circle(
        legendaX + 1.1,
        legendaY - 0.7,
        1.05,
        "F"
      );

      pdf.setFont(
        "Inter",
        "normal"
      );
      pdf.setFontSize(5.35);
      nastavFarbu(
        pdf,
        FARBA_TEXT
      );

      pdf.text(
        polozka.nazov,
        legendaX + 3.2,
        legendaY,
        {
          maxWidth:
            legendaSirka - 13,
        }
      );

      pdf.setFont(
        "Inter",
        "bold"
      );

      pdf.text(
        `${formatujCislo(
          polozka.podiel
        )} %`,
        legendaX + legendaSirka,
          legendaY,
          {
            align: "right",
          }
      );

      legendaY += 4.2;
    }
  );
}

function rozdelPolozky(
  polozky,
  velkostSkupiny
) {
  return [
    polozky.slice(
      0,
      velkostSkupiny
    ),

    polozky.slice(
      velkostSkupiny,
      velkostSkupiny * 2
    ),
  ].filter(
    (skupina) =>
      skupina.length > 0
  );
}

function zistiStlpce(
  odporucania
) {
  if (
    odporucania.typ ===
    "jedenProdukt"
  ) {
    return [
      [
        odporucania.produkt,
      ],
    ];
  }

  if (
    odporucania.typ ===
    "viacProduktov"
  ) {
    return odporucania
      .produkty.length > 2
      ? rozdelPolozky(
          odporucania.produkty,
          2
        )
      : [
          odporucania.produkty,
        ];
  }

  return odporucania
    .fondy.length > 4
    ? rozdelPolozky(
        odporucania.fondy,
        4
      )
    : [
        odporucania.fondy,
      ];
}

function zistiVyskuObsahu(
  odporucania,
  skupiny
) {
  const minimalnaVyskaGrafu =
    odporucania.typ ===
      "jedenProdukt"
      ? 42
      : ROZLOZENIE
          .minimalnaVyskaGrafu;

  const vyskaGrafu =
    Math.max(
      minimalnaVyskaGrafu,
      12 +
        (
          odporucania
            ?.zlozenie
            ?.length || 0
        ) *
          4.2
    );

  if (
    odporucania.typ ===
    "vlastnaVolba"
  ) {
    const vyskySkupin =
      skupiny.map(
        (skupina, index) => {
          let vyska =
            skupina.length *
            ROZLOZENIE
              .vyskaFondu;

          vyska += 8;

          if (
            index ===
              skupiny.length - 1 &&
            odporucania
              .meta.length > 0
          ) {
            vyska += 7;
          }

          return vyska;
        }
      );

    return Math.max(
      vyskaGrafu,
      ...vyskySkupin
    );
  }

  const najviacProduktov =
    Math.max(
      1,
      ...skupiny.map(
        (skupina) =>
          skupina.length
      )
    );

  return Math.max(
    vyskaGrafu,
    najviacProduktov *
      ROZLOZENIE
        .vyskaProduktu
  );
}

export function zapisInvestPdfOdporucania(
  pdf,
  stav,
  odporucania
) {
  if (
    !maInvestPdfOdporucania(
      odporucania
    )
  ) {
    return;
  }

  const skupiny =
    zistiStlpce(
      odporucania
    );

  const pocetStlpcov =
    skupiny.length + 1;

  const vyskaObsahu =
    zistiVyskuObsahu(
        odporucania,
        skupiny
    );

    const vyskaBloku =
    ROZLOZENIE.padding * 2 +
    ROZLOZENIE.vyskaNadpisu +
    vyskaObsahu;

  zabezpecInvestPdfMiesto(
    pdf,
    stav,
    vyskaBloku +
      ROZLOZENIE
        .odsadenieZaBlokom
  );

  const x =
    INVEST_PDF_OKRAJ_X;

  const y = stav.y;

  const vnutornaSirka =
    INVEST_PDF_SIRKA_OBSAHU -
    ROZLOZENIE.padding * 2 -
    ROZLOZENIE
      .medzeraStlpcov *
      (pocetStlpcov - 1);

  const sirkaStlpca =
    vnutornaSirka /
    pocetStlpcov;

  const obsahY =
    y +
    ROZLOZENIE.padding +
    ROZLOZENIE.vyskaNadpisu;

  const typografiaProduktu =
    odporucania.typ ===
      "jedenProdukt"
      ? TYPOGRAFIA_PRODUKTU
          .jedenProdukt
      : TYPOGRAFIA_PRODUKTU
          .viacProduktov;

  nastavFarbu(
    pdf,
    FARBA_LINKA,
    "draw"
  );

  pdf.setLineWidth(0.35);

  pdf.roundedRect(
    x,
    y,
    INVEST_PDF_SIRKA_OBSAHU,
    vyskaBloku,
    3,
    3,
    "S"
  );

  pdf.setFont(
    "Inter",
    "bold"
  );
  pdf.setFontSize(8.2);
  nastavFarbu(
    pdf,
    FARBA_NADPIS
  );

  pdf.text(
    "Návrh investičného riešenia",
    x + ROZLOZENIE.padding,
    y + 6.2
  );

  pdf.setFont(
    "Inter",
    "normal"
  );
  pdf.setFontSize(6.2);
  nastavFarbu(
    pdf,
    FARBA_JEMNA
  );

  pdf.text(
    odporucania.variant,
    x +
      INVEST_PDF_SIRKA_OBSAHU -
      ROZLOZENIE.padding,
    y + 6.2,
    {
      align: "right",
    }
  );

  skupiny.forEach(
    (skupina, index) => {
      const stlpecX =
        x +
        ROZLOZENIE.padding +
        index *
          (
            sirkaStlpca +
            ROZLOZENIE
              .medzeraStlpcov
          );

      if (
        odporucania.typ ===
        "vlastnaVolba"
      ) {
        if (index === 0) {
          pdf.setFont(
            "Inter",
            "normal"
          );
          pdf.setFontSize(
            TYPOGRAFIA_PRODUKTU
              .vlastnaVolba
              .spolocnost
          );
          nastavFarbu(
            pdf,
            FARBA_JEMNA
          );

          if (
            odporucania
              .spolocnost
          ) {
            pdf.text(
              odporucania
                .spolocnost,
              stlpecX,
              obsahY + 3
            );
          }

          pdf.setFont(
            "Inter",
            "bold"
          );
          pdf.setFontSize(
            TYPOGRAFIA_PRODUKTU
              .vlastnaVolba
              .nazov
          );
          nastavFarbu(
            pdf,
            FARBA_TEXT
          );

          pdf.text(
            odporucania.nazov,
            stlpecX,
            obsahY +
              (
                odporucania
                  .spolocnost
                  ? 6
                  : 3
              )
          );
        }

        const zaciatokFondov =
          obsahY + 8;

        const koniecFondov =
          zapisFondy(
            pdf,
            stlpecX,
            zaciatokFondov,
            sirkaStlpca,
            skupina
          );

        if (
          index ===
            skupiny.length - 1 &&
          odporucania.meta.length >
            0
        ) {
          pdf.setFont(
            "Inter",
            "normal"
          );
          pdf.setFontSize(
            TYPOGRAFIA_PRODUKTU
              .vlastnaVolba
              .meta
          );
          nastavFarbu(
            pdf,
            FARBA_JEMNA
          );

          zapisZalamanyText(
            pdf,
            odporucania.meta.join(
              "  |  "
            ),
            stlpecX,
            Math.min(
                obsahY +
                    vyskaObsahu -
                    2,
                koniecFondov + 2.2
                ),
            sirkaStlpca,
            {
              lineHeightFactor:
                1.05,
            }
          );
        }
      } else {
        skupina.forEach(
          (
            produkt,
            produktIndex
          ) => {
            zapisProdukt(
              pdf,
              produkt,
              stlpecX,
              obsahY +
                produktIndex *
                  ROZLOZENIE
                    .vyskaProduktu,
              sirkaStlpca,
              ROZLOZENIE
                .vyskaProduktu -
                1,
              {
                typografia:
                  typografiaProduktu,

                zobrazDeliciuCiaru:
                  odporucania.typ !==
                  "jedenProdukt",
              }
            );
          }
        );
      }

      if (
        index <
        pocetStlpcov - 1
      ) {
        const dividerX =
          stlpecX +
          sirkaStlpca +
          ROZLOZENIE
            .medzeraStlpcov /
            2;

        nastavFarbu(
          pdf,
          FARBA_LINKA,
          "draw"
        );

        pdf.setLineWidth(0.18);

        pdf.line(
            dividerX,
            obsahY,
            dividerX,
            obsahY + vyskaObsahu
            );
      }
    }
  );

  const grafX =
    x +
    ROZLOZENIE.padding +
    skupiny.length *
      (
        sirkaStlpca +
        ROZLOZENIE
          .medzeraStlpcov
      );

  zapisZlozenie(
    pdf,
    odporucania,
    grafX,
    obsahY,
    sirkaStlpca,
    {
      zvacsenyGraf:
        odporucania.typ ===
        "jedenProdukt",
    }
  );

  stav.y +=
    vyskaBloku +
    ROZLOZENIE
      .odsadenieZaBlokom;
}